module.exports = "/_next/static/images/braintext-fc565d9211431c4da59f8fc6541b5acf.png";